import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { endpoints } from '../endpoints';
import { environment } from '../../environments/environments';
import { IThreat, IThreatCourseOfAction } from '../models/threat';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class ThreatService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

  getThreats(buildingId: string): Observable<{has_error: boolean, message: string, data: IThreat[]}> {
    const url = environment.apiBaseUrl + endpoints.threats.replace(':buildingId', buildingId);
    return this.http.get<{has_error: boolean, message: string, data: IThreat[]}>(url).pipe(
      catchError(this.errorService.handleError)
    )
  }

  getThreatGoals(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.threatGoals.replace(':buildingId', buildingId);
    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    )
  }

  getCourseOfAction(buildingId: string, threatId: number): Observable<{has_error: boolean, message: string, data: IThreatCourseOfAction[]}> {
    const url = environment.apiBaseUrl + endpoints.getThreatsCourseOfAction.replace(':buildingId', buildingId).replace(':threatId', threatId+'');
    return this.http.get<{has_error: boolean, message: string, data: IThreatCourseOfAction[]}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  createNewThreat(buildingId: string, threatData: any): Observable<{has_error: boolean, message: string, data: IThreat[]}> {
    const url = environment.apiBaseUrl + endpoints.createNewThreat.replace(':buildingId', buildingId);
    return this.http.post<{has_error: boolean, message: string, data: IThreat[]}>(url, threatData).pipe(
      catchError(this.errorService.handleError)
    )
  }

  editThreat(threatData: any, threatId: number): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.editThreat.replace(':threatId', threatId+'');
    return this.http.put<{has_error: boolean, message: string, data: any}>(url, threatData).pipe(
      catchError(this.errorService.handleError)
    )
  }

  deleteThreat(threatId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.deleteThreat.replace(':threatId', threatId);
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    )
  }

  createNewThreatGoals(threatId: number, threatData: any): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.createThreatGoals.replace(':threatId', threatId+'');
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, threatData).pipe(
      catchError(this.errorService.handleError)
    )
  }

  editThreatGoals(threatId: number, threatData: any): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.editThreatGoals.replace(':threatId', threatId+'');
    return this.http.put<{has_error: boolean, message: string, data: any}>(url, threatData).pipe(
      catchError(this.errorService.handleError)
    )
  }

  deleteThreatGoals(threatId: number): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.deleteThreatGoals.replace(':threatId', threatId+'');
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    )
  }
  
  saveCourseOfAction(courseOfAction: IThreatCourseOfAction): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.updateThreatesCourseOfAction;
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, courseOfAction).pipe(
    catchError(this.errorService.handleError)
    );
  }
}